import { Paper, Box, styled } from "@mui/material";

interface IProps {
  children: any;
}

const CustomBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.neutral0.main,
  width: "100%",
  alignItems: "center",
  maxWidth: "100%",
  height: "fit-content",
  borderRadius: "8px",
  [theme.breakpoints.down("md")]: {
    padding: "0%",
  },
}));

export function ContentBox({ children }: IProps) {
  return (
    <CustomBox>
      <Paper
        sx={{
          display: "grid",
          // gridRowGap: "20px",
          width: "100%",
          padding: { xs: "10% 10%", sm: "5% 10%" },
          justifyItems: "center",
          minHeight: "600px",
          borderRadius: "8px",
        }}
      >
        {children}
      </Paper>
    </CustomBox>
  );
}
